/**
 * ResizableHeader - Shared drag-to-resize column header component.
 *
 * Defined OUTSIDE any parent component so React never creates a new
 * component type on parent re-renders (which would cause unmount/remount
 * of every header cell and extreme fiber reconciliation with large datasets).
 *
 * Props:
 *   col       - column definition { key, width, ... }
 *   formName  - localStorage key prefix for persisted column widths
 *   onResize  - stable callback(key, newWidth, formName) – use useCallback in parent
 *   children  - header cell content
 */
import React from "react";

function ResizableHeader({ col, formName, onResize, children }) {
  const handleMouseDown = (e) => {
    e.preventDefault();
    const startX = e.clientX;
    const startWidth = col.width;

    const onMouseMove = (mv) => {
      const newWidth = Math.max(30, startWidth + (mv.clientX - startX));
      onResize(col.key, newWidth, formName);
    };

    const onMouseUp = () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };

    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  };

  return (
    <div className="relative flex h-full w-full items-center justify-center">
      {children}
      <div
        className="absolute right-0 top-0 h-full w-2 cursor-col-resize bg-transparent hover:bg-white/20 transition-colors z-20"
        onMouseDown={handleMouseDown}
      />
    </div>
  );
}

export default ResizableHeader;
